var _rect, _circle, _path, _path2, _rect2, _g, _path3, _path4, _g2, _g3, _path5, _path6, _g4, _path7, _g5, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 482,
    viewBox: "0 0 618 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_171_10551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 618,
    height: 482
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 618,
    height: 482,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_171_10551)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 241,
    r: 238,
    fill: "url(#paint0_linear_171_10551)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 302.417C97.0812 404.094 189.793 479 300 479C410.207 479 502.919 404.094 530 302.417",
    stroke: "#FF2954",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 406H551V482H38V406Z",
    fill: "url(#paint1_linear_171_10551)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 513,
    height: 66,
    fill: "url(#paint2_linear_171_10551)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1,
    y: 177,
    width: 128,
    height: 128
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_171_10551_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_171_10551)",
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 241,
    r: 54,
    fill: "#F4234D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 241.5H202",
    stroke: "#FF2954",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2981 240.8C34.2981 243.6 35.5781 244.56 37.0981 244.56C38.6181 244.56 39.4981 243.76 39.6581 242.24H42.0581C41.9781 244.4 40.3941 246.24 37.0981 246.24C33.6581 246.24 31.8981 243.92 31.8981 240.8C31.8981 237.68 33.6581 235.36 37.0981 235.36C40.3781 235.36 41.9781 237.2 42.0581 239.36H39.6581C39.4981 237.92 38.6181 237.04 37.0981 237.04C35.5781 237.04 34.2981 238 34.2981 240.8ZM48.455 238H50.535V246H48.455V244.48C48.455 244.48 47.335 246.24 45.575 246.24C43.655 246.24 42.855 245.04 42.855 243.28V238H44.935V242.72C44.935 244.08 45.495 244.56 46.455 244.56C47.415 244.56 48.455 243.84 48.455 242V238ZM53.5756 246H51.4956V238H53.5756V240.144C53.6076 240.032 54.4236 237.84 56.2956 237.84H56.5356V240H55.9756C54.8556 240 53.5756 240.64 53.5756 242.72V246ZM57.1031 240.4C57.1031 238.72 58.5431 237.76 60.7031 237.76C63.1831 237.76 64.4631 238.56 64.4631 240.32V244C64.4631 245.6 64.8631 245.92 64.8631 245.92V246H62.6231C62.6231 246 62.3831 245.84 62.3831 244.88V244.8C62.3831 244.8 61.5831 246.24 59.6631 246.24C57.7431 246.24 56.9431 245.04 56.9431 243.68C56.9431 242.08 57.9831 241.04 60.6231 241.04C62.2231 241.04 62.3831 240.64 62.3831 240.24C62.3831 239.68 61.9831 239.2 60.7831 239.2C59.4231 239.2 59.1831 239.84 59.1831 240.4H57.1031ZM62.3831 242.56V241.856C62.3671 241.872 61.8711 242.4 60.4631 242.4C59.4231 242.4 58.9431 242.88 58.9431 243.52C58.9431 244.32 59.4231 244.72 60.3031 244.72C61.2631 244.72 62.3831 244.08 62.3831 242.56ZM65.0231 239.6V238H66.6231V235.6H68.7031V238H70.4631V239.6H68.7031V243.68C68.7031 244.4 68.9431 244.56 69.5031 244.56C69.8231 244.56 70.4631 244.48 70.4631 244.48V246C70.4631 246 69.4231 246.16 68.7031 246.16C67.0231 246.16 66.6231 245.6 66.6231 243.68V239.6H65.0231ZM70.8669 242C70.8669 239.68 72.1469 237.76 75.0269 237.76C77.9069 237.76 79.1869 239.68 79.1869 242C79.1869 244.32 77.9069 246.24 75.0269 246.24C72.1469 246.24 70.8669 244.32 70.8669 242ZM73.0269 242C73.0269 244.08 73.9869 244.8 75.0269 244.8C76.0669 244.8 77.0269 244.08 77.0269 242C77.0269 239.92 76.0669 239.2 75.0269 239.2C73.9869 239.2 73.0269 239.92 73.0269 242ZM82.06 246H79.98V238H82.06V240.144C82.092 240.032 82.908 237.84 84.78 237.84H85.02V240H84.46C83.34 240 82.06 240.64 82.06 242.72V246ZM85.4275 243.36H87.5875C87.5875 244.32 88.3075 244.8 89.3475 244.8C90.7075 244.8 91.0275 244.08 91.0275 243.52C91.0275 242.96 90.7075 242.48 89.0275 242.48C86.5475 242.48 85.5875 241.68 85.5875 240.24C85.5875 238.88 86.7875 237.76 89.2675 237.76C92.4675 237.76 92.8675 239.52 92.8675 240.4H90.7875C90.7875 239.76 90.3875 239.2 89.1875 239.2C88.0675 239.2 87.6675 239.76 87.6675 240.16C87.6675 240.56 87.9075 241.04 89.5075 241.04C91.8275 241.04 93.1875 241.6 93.1875 243.44C93.1875 244.96 91.9875 246.24 89.3475 246.24C86.3875 246.24 85.4275 244.8 85.4275 243.36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 464,
    y: 167,
    width: 148,
    height: 148
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_171_10551_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_171_10551)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 241,
    r: 54,
    fill: "url(#paint3_linear_171_10551)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 192,
    y: 133,
    width: 216,
    height: 216
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_2_171_10551_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_171_10551)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 241,
    r: 88,
    fill: "url(#paint4_linear_171_10551)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M380.42 205.221C385.291 216.152 388 228.26 388 241C388 289.601 348.601 329 300 329C287.26 329 275.152 326.291 264.221 321.42C272.413 323.751 281.06 325 290 325C341.915 325 384 282.915 384 231C384 222.06 382.751 213.413 380.42 205.221Z",
    fill: "white",
    fillOpacity: 0.07,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 153C322.418 153 342.877 161.382 358.416 175.184C346.688 169.925 333.685 167 320 167C268.085 167 226 209.085 226 261C226 274.685 228.925 287.688 234.184 299.416C220.382 283.877 212 263.418 212 241C212 192.399 251.399 153 300 153Z",
    fill: "white",
    fillOpacity: 0.08,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M522.543 246V235.6H526.223C529.743 235.6 531.903 237.36 531.903 240.8C531.903 244.24 529.743 246 526.223 246H522.543ZM524.703 244.24H526.383C527.903 244.24 529.503 243.44 529.503 240.8C529.503 238.16 527.903 237.36 526.383 237.36H524.703V244.24ZM540.619 242.4H534.715C534.811 244.176 535.659 244.8 536.779 244.8C537.739 244.8 538.299 244.16 538.459 243.36H540.539C540.219 244.88 539.179 246.24 536.699 246.24C533.899 246.24 532.539 244.32 532.539 242C532.539 239.68 533.899 237.76 536.699 237.76C539.179 237.76 540.619 239.36 540.619 241.76V242.4ZM536.699 239.2C535.835 239.2 535.019 239.648 534.763 241.04H538.459C538.379 239.76 537.659 239.2 536.699 239.2ZM541.418 246V235.6H549.578V237.36H543.578V239.92H548.378V241.68H543.578V246H541.418ZM550.371 237.36V235.6H552.451V237.36H550.371ZM550.371 246V238H552.451V246H550.371Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.851 229.3H254.751C254.751 231.4 256.051 232.2 257.751 232.2C259.751 232.2 260.651 231.3 260.651 230.1C260.651 229.2 260.051 228.3 257.451 228.3C253.251 228.3 252.051 226.7 252.051 224.8C252.051 222.5 253.951 220.7 257.751 220.7C262.351 220.7 263.251 223.1 263.251 225H260.351C260.351 223.8 259.651 222.8 257.651 222.8C255.751 222.8 255.051 223.7 255.051 224.6C255.051 225.5 255.951 226.1 258.051 226.1C262.051 226.1 263.651 227.5 263.651 229.8C263.651 232.7 261.251 234.3 257.751 234.3C253.651 234.3 251.851 232.3 251.851 229.3ZM263.845 226V224H265.845V221H268.445V224H270.645V226H268.445V231.1C268.445 232 268.745 232.2 269.445 232.2C269.845 232.2 270.645 232.1 270.645 232.1V234C270.645 234 269.345 234.2 268.445 234.2C266.345 234.2 265.845 233.5 265.845 231.1V226H263.845ZM274.341 234H271.741V224H274.341V226.68C274.381 226.54 275.401 223.8 277.741 223.8H278.041V226.5H277.341C275.941 226.5 274.341 227.3 274.341 229.9V234ZM286.045 224H288.645V234H286.045V232.1C286.045 232.1 284.645 234.3 282.445 234.3C280.045 234.3 279.045 232.8 279.045 230.6V224H281.645V229.9C281.645 231.6 282.345 232.2 283.545 232.2C284.745 232.2 286.045 231.3 286.045 229V224ZM292.346 229C292.346 231.7 293.546 232.5 294.846 232.5C296.046 232.5 296.946 231.7 297.046 230.2H299.746C299.646 232.4 298.146 234.3 294.846 234.3C291.346 234.3 289.646 231.9 289.646 229C289.646 226.1 291.346 223.7 294.846 223.7C298.146 223.7 299.646 225.6 299.746 227.8H297.046C296.946 226.3 296.046 225.5 294.846 225.5C293.546 225.5 292.346 226.3 292.346 229ZM299.939 226V224H301.939V221H304.539V224H306.739V226H304.539V231.1C304.539 232 304.839 232.2 305.539 232.2C305.939 232.2 306.739 232.1 306.739 232.1V234C306.739 234 305.439 234.2 304.539 234.2C302.439 234.2 301.939 233.5 301.939 231.1V226H299.939ZM314.834 224H317.434V234H314.834V232.1C314.834 232.1 313.434 234.3 311.234 234.3C308.834 234.3 307.834 232.8 307.834 230.6V224H310.434V229.9C310.434 231.6 311.134 232.2 312.334 232.2C313.534 232.2 314.834 231.3 314.834 229V224ZM321.235 234H318.635V224H321.235V226.68C321.275 226.54 322.295 223.8 324.635 223.8H324.935V226.5H324.235C322.835 226.5 321.235 227.3 321.235 229.9V234ZM335.547 229.5H328.167C328.287 231.72 329.347 232.5 330.747 232.5C331.947 232.5 332.647 231.7 332.847 230.7H335.447C335.047 232.6 333.747 234.3 330.647 234.3C327.147 234.3 325.447 231.9 325.447 229C325.447 226.1 327.147 223.7 330.647 223.7C333.747 223.7 335.547 225.7 335.547 228.7V229.5ZM330.647 225.5C329.567 225.5 328.547 226.06 328.227 227.8H332.847C332.747 226.2 331.847 225.5 330.647 225.5ZM344.245 221H346.845V234H344.245V232.3C344.245 232.3 343.245 234.3 340.845 234.3C338.445 234.3 336.345 232.6 336.345 229C336.345 225.4 338.445 223.7 340.845 223.7C343.245 223.7 344.245 225.5 344.245 225.5V221ZM339.045 229C339.045 231.5 340.345 232.5 341.645 232.5C342.945 232.5 344.245 231.5 344.245 229C344.245 226.5 342.945 225.5 341.645 225.5C340.345 225.5 339.045 226.5 339.045 229ZM264.905 264V251H271.105C273.905 251 275.905 252.1 275.905 254.9C275.905 257.7 273.905 258.8 271.105 258.8H267.605V264H264.905ZM267.605 253.2V256.6H271.105C272.205 256.6 272.905 256 272.905 254.9C272.905 253.8 272.205 253.2 271.105 253.2H267.605ZM279.399 264H276.799V254H279.399V256.68C279.439 256.54 280.459 253.8 282.799 253.8H283.099V256.5H282.399C280.999 256.5 279.399 257.3 279.399 259.9V264ZM283.611 259C283.611 256.1 285.211 253.7 288.811 253.7C292.411 253.7 294.011 256.1 294.011 259C294.011 261.9 292.411 264.3 288.811 264.3C285.211 264.3 283.611 261.9 283.611 259ZM286.311 259C286.311 261.6 287.511 262.5 288.811 262.5C290.111 262.5 291.311 261.6 291.311 259C291.311 256.4 290.111 255.5 288.811 255.5C287.511 255.5 286.311 256.4 286.311 259ZM302.702 251H305.302V264H302.702V262.3C302.702 262.3 301.702 264.3 299.302 264.3C296.902 264.3 294.802 262.6 294.802 259C294.802 255.4 296.902 253.7 299.302 253.7C301.702 253.7 302.702 255.5 302.702 255.5V251ZM297.502 259C297.502 261.5 298.802 262.5 300.102 262.5C301.402 262.5 302.702 261.5 302.702 259C302.702 256.5 301.402 255.5 300.102 255.5C298.802 255.5 297.502 256.5 297.502 259ZM313.506 254H316.106V264H313.506V262.1C313.506 262.1 312.106 264.3 309.906 264.3C307.506 264.3 306.506 262.8 306.506 260.6V254H309.106V259.9C309.106 261.6 309.806 262.2 311.006 262.2C312.206 262.2 313.506 261.3 313.506 259V254ZM319.807 259C319.807 261.7 321.007 262.5 322.307 262.5C323.507 262.5 324.407 261.7 324.507 260.2H327.207C327.107 262.4 325.607 264.3 322.307 264.3C318.807 264.3 317.107 261.9 317.107 259C317.107 256.1 318.807 253.7 322.307 253.7C325.607 253.7 327.107 255.6 327.207 257.8H324.507C324.407 256.3 323.507 255.5 322.307 255.5C321.007 255.5 319.807 256.3 319.807 259ZM327.4 256V254H329.4V251H332V254H334.2V256H332V261.1C332 262 332.3 262.2 333 262.2C333.4 262.2 334.2 262.1 334.2 262.1V264C334.2 264 332.9 264.2 332 264.2C329.9 264.2 329.4 263.5 329.4 261.1V256H327.4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_171_10551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223 94C223 80.7452 233.745 70 247 70H354C367.255 70 378 80.7452 378 94C378 107.255 367.255 118 354 118H247C233.745 118 223 107.255 223 94Z",
    fill: "url(#paint5_linear_171_10551)",
    fillOpacity: 0.6
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M247.779 98V89.55H249.534V96.57H254.344V98H247.779ZM254.99 90.98V89.55H256.68V90.98H254.99ZM254.99 98V91.5H256.68V98H254.99ZM262.471 91.5H264.161V99.95H262.471V96.895C262.471 96.895 261.821 98.195 260.261 98.195C258.701 98.195 257.336 97.09 257.336 94.75C257.336 92.41 258.701 91.305 260.261 91.305C261.821 91.305 262.471 92.475 262.471 92.475V91.5ZM259.091 94.75C259.091 96.375 259.936 97.025 260.781 97.025C261.626 97.025 262.471 96.375 262.471 94.75C262.471 93.125 261.626 92.475 260.781 92.475C259.936 92.475 259.091 93.125 259.091 94.75ZM269.493 91.5H271.183V98H269.493V96.765C269.493 96.765 268.583 98.195 267.153 98.195C265.593 98.195 264.943 97.22 264.943 95.79V91.5H266.633V95.335C266.633 96.44 267.088 96.83 267.868 96.83C268.648 96.83 269.493 96.245 269.493 94.75V91.5ZM271.964 90.98V89.55H273.654V90.98H271.964ZM271.964 98V91.5H273.654V98H271.964ZM279.444 89.55H281.134V98H279.444V96.895C279.444 96.895 278.794 98.195 277.234 98.195C275.674 98.195 274.309 97.09 274.309 94.75C274.309 92.41 275.674 91.305 277.234 91.305C278.794 91.305 279.444 92.475 279.444 92.475V89.55ZM276.064 94.75C276.064 96.375 276.909 97.025 277.754 97.025C278.599 97.025 279.444 96.375 279.444 94.75C279.444 93.125 278.599 92.475 277.754 92.475C276.909 92.475 276.064 93.125 276.064 94.75ZM281.917 90.98V89.55H283.607V90.98H281.917ZM281.917 98V91.5H283.607V98H281.917ZM284.262 92.8V91.5H285.562V89.55H287.252V91.5H288.682V92.8H287.252V96.115C287.252 96.7 287.447 96.83 287.902 96.83C288.162 96.83 288.682 96.765 288.682 96.765V98C288.682 98 287.837 98.13 287.252 98.13C285.887 98.13 285.562 97.675 285.562 96.115V92.8H284.262ZM289.133 91.5H291.018L292.747 96.193L294.268 91.5H296.153L293.683 98.065C293.293 99.118 292.773 100.015 291.213 100.015C290.433 100.015 290.173 99.95 290.173 99.95V98.676C290.173 98.676 290.498 98.715 290.888 98.715C291.473 98.715 291.733 98.455 291.863 98L289.133 91.5ZM299.208 98V89.55H303.238C305.058 89.55 306.358 90.265 306.358 92.085C306.358 93.905 305.058 94.62 303.238 94.62H300.963V98H299.208ZM300.963 90.98V93.19H303.238C303.953 93.19 304.408 92.8 304.408 92.085C304.408 91.37 303.953 90.98 303.238 90.98H300.963ZM308.629 98H306.939V91.5H308.629V93.242C308.655 93.151 309.318 91.37 310.839 91.37H311.034V93.125H310.579C309.669 93.125 308.629 93.645 308.629 95.335V98ZM311.367 94.75C311.367 92.865 312.407 91.305 314.747 91.305C317.087 91.305 318.127 92.865 318.127 94.75C318.127 96.635 317.087 98.195 314.747 98.195C312.407 98.195 311.367 96.635 311.367 94.75ZM313.122 94.75C313.122 96.44 313.902 97.025 314.747 97.025C315.592 97.025 316.372 96.44 316.372 94.75C316.372 93.06 315.592 92.475 314.747 92.475C313.902 92.475 313.122 93.06 313.122 94.75ZM321.628 96.375L323.318 91.5H325.203L322.603 98H320.653L318.053 91.5H319.938L321.628 96.375ZM325.652 90.98V89.55H327.342V90.98H325.652ZM325.652 98V91.5H327.342V98H325.652ZM333.133 89.55H334.823V98H333.133V96.895C333.133 96.895 332.483 98.195 330.923 98.195C329.363 98.195 327.998 97.09 327.998 94.75C327.998 92.41 329.363 91.305 330.923 91.305C332.483 91.305 333.133 92.475 333.133 92.475V89.55ZM329.753 94.75C329.753 96.375 330.598 97.025 331.443 97.025C332.288 97.025 333.133 96.375 333.133 94.75C333.133 93.125 332.288 92.475 331.443 92.475C330.598 92.475 329.753 93.125 329.753 94.75ZM342.04 95.075H337.243C337.321 96.518 338.01 97.025 338.92 97.025C339.7 97.025 340.155 96.505 340.285 95.855H341.975C341.715 97.09 340.87 98.195 338.855 98.195C336.58 98.195 335.475 96.635 335.475 94.75C335.475 92.865 336.58 91.305 338.855 91.305C340.87 91.305 342.04 92.605 342.04 94.555V95.075ZM338.855 92.475C338.153 92.475 337.49 92.839 337.282 93.97H340.285C340.22 92.93 339.635 92.475 338.855 92.475ZM344.379 98H342.689V91.5H344.379V93.242C344.405 93.151 345.068 91.37 346.589 91.37H346.784V93.125H346.329C345.419 93.125 344.379 93.645 344.379 95.335V98ZM347.115 95.855H348.87C348.87 96.635 349.455 97.025 350.3 97.025C351.405 97.025 351.665 96.44 351.665 95.985C351.665 95.53 351.405 95.14 350.04 95.14C348.025 95.14 347.245 94.49 347.245 93.32C347.245 92.215 348.22 91.305 350.235 91.305C352.835 91.305 353.16 92.735 353.16 93.45H351.47C351.47 92.93 351.145 92.475 350.17 92.475C349.26 92.475 348.935 92.93 348.935 93.255C348.935 93.58 349.13 93.97 350.43 93.97C352.315 93.97 353.42 94.425 353.42 95.92C353.42 97.155 352.445 98.195 350.3 98.195C347.895 98.195 347.115 97.025 347.115 95.855Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_171_10551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237 384C237 370.745 247.745 360 261 360H340C353.255 360 364 370.745 364 384C364 397.255 353.255 408 340 408H261C247.745 408 237 397.255 237 384Z",
    fill: "url(#paint6_linear_171_10551)",
    fillOpacity: 0.6
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.41 388H264.642V384.685L261.171 379.55H263.251L265.526 383.19L267.801 379.55H269.881L266.41 384.685V388ZM270.332 380.98V379.55H272.022V380.98H270.332ZM270.332 388V381.5H272.022V388H270.332ZM279.243 385.075H274.446C274.524 386.518 275.213 387.025 276.123 387.025C276.903 387.025 277.358 386.505 277.488 385.855H279.178C278.918 387.09 278.073 388.195 276.058 388.195C273.783 388.195 272.678 386.635 272.678 384.75C272.678 382.865 273.783 381.305 276.058 381.305C278.073 381.305 279.243 382.605 279.243 384.555V385.075ZM276.058 382.475C275.356 382.475 274.693 382.839 274.485 383.97H277.488C277.423 382.93 276.838 382.475 276.058 382.475ZM279.892 388V379.55H281.582V388H279.892ZM287.373 379.55H289.063V388H287.373V386.895C287.373 386.895 286.723 388.195 285.163 388.195C283.603 388.195 282.238 387.09 282.238 384.75C282.238 382.41 283.603 381.305 285.163 381.305C286.723 381.305 287.373 382.475 287.373 382.475V379.55ZM283.993 384.75C283.993 386.375 284.838 387.025 285.683 387.025C286.528 387.025 287.373 386.375 287.373 384.75C287.373 383.125 286.528 382.475 285.683 382.475C284.838 382.475 283.993 383.125 283.993 384.75ZM292.253 384.945H294.138C294.138 386.31 294.983 386.83 296.088 386.83C297.388 386.83 297.973 386.245 297.973 385.465C297.973 384.88 297.583 384.295 295.893 384.295C293.163 384.295 292.383 383.255 292.383 382.02C292.383 380.525 293.618 379.355 296.088 379.355C299.078 379.355 299.663 380.915 299.663 382.15H297.778C297.778 381.37 297.323 380.72 296.023 380.72C294.788 380.72 294.333 381.305 294.333 381.89C294.333 382.475 294.918 382.865 296.283 382.865C298.883 382.865 299.923 383.775 299.923 385.27C299.923 387.155 298.363 388.195 296.088 388.195C293.423 388.195 292.253 386.895 292.253 384.945ZM300.443 384.75C300.443 382.865 301.483 381.305 303.823 381.305C306.163 381.305 307.203 382.865 307.203 384.75C307.203 386.635 306.163 388.195 303.823 388.195C301.483 388.195 300.443 386.635 300.443 384.75ZM302.198 384.75C302.198 386.44 302.978 387.025 303.823 387.025C304.668 387.025 305.448 386.44 305.448 384.75C305.448 383.06 304.668 382.475 303.823 382.475C302.978 382.475 302.198 383.06 302.198 384.75ZM312.397 381.5H314.087V388H312.397V386.765C312.397 386.765 311.487 388.195 310.057 388.195C308.497 388.195 307.847 387.22 307.847 385.79V381.5H309.537V385.335C309.537 386.44 309.992 386.83 310.772 386.83C311.552 386.83 312.397 386.245 312.397 384.75V381.5ZM316.558 388H314.868V381.5H316.558V383.242C316.584 383.151 317.247 381.37 318.768 381.37H318.963V383.125H318.508C317.598 383.125 316.558 383.645 316.558 385.335V388ZM321.05 384.75C321.05 386.505 321.83 387.025 322.675 387.025C323.455 387.025 324.04 386.505 324.105 385.53H325.86C325.795 386.96 324.82 388.195 322.675 388.195C320.4 388.195 319.295 386.635 319.295 384.75C319.295 382.865 320.4 381.305 322.675 381.305C324.82 381.305 325.795 382.54 325.86 383.97H324.105C324.04 382.995 323.455 382.475 322.675 382.475C321.83 382.475 321.05 382.995 321.05 384.75ZM332.944 385.075H328.147C328.225 386.518 328.914 387.025 329.824 387.025C330.604 387.025 331.059 386.505 331.189 385.855H332.879C332.619 387.09 331.774 388.195 329.759 388.195C327.484 388.195 326.379 386.635 326.379 384.75C326.379 382.865 327.484 381.305 329.759 381.305C331.774 381.305 332.944 382.605 332.944 384.555V385.075ZM329.759 382.475C329.057 382.475 328.394 382.839 328.186 383.97H331.189C331.124 382.93 330.539 382.475 329.759 382.475ZM333.398 385.855H335.153C335.153 386.635 335.738 387.025 336.583 387.025C337.688 387.025 337.948 386.44 337.948 385.985C337.948 385.53 337.688 385.14 336.323 385.14C334.308 385.14 333.528 384.49 333.528 383.32C333.528 382.215 334.503 381.305 336.518 381.305C339.118 381.305 339.443 382.735 339.443 383.45H337.753C337.753 382.93 337.428 382.475 336.453 382.475C335.543 382.475 335.218 382.93 335.218 383.255C335.218 383.58 335.413 383.97 336.713 383.97C338.598 383.97 339.703 384.425 339.703 385.92C339.703 387.155 338.728 388.195 336.583 388.195C334.178 388.195 333.398 387.025 333.398 385.855Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_171_10551",
    x: -1,
    y: 177,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_171_10551"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_171_10551_clip_path",
    transform: "translate(1 -177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 241,
    r: 54
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_171_10551",
    x: 464,
    y: 167,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_171_10551"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_171_10551_clip_path",
    transform: "translate(-464 -167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 241,
    r: 54
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_171_10551",
    x: 192,
    y: 133,
    width: 216,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_171_10551"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_171_10551_clip_path",
    transform: "translate(-192 -133)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 241,
    r: 88
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_171_10551",
    x: 223,
    y: 70,
    width: 155,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_171_10551"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_171_10551",
    x: 237,
    y: 360,
    width: 127,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_171_10551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_10551",
    x1: 300,
    y1: 3,
    x2: 300,
    y2: 479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363945",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171_10551",
    x1: 38,
    y1: 416,
    x2: 38,
    y2: 482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18191F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18191F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171_10551",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.100962,
    stopColor: "#18191F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18191F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171_10551",
    x1: 538,
    y1: 187,
    x2: 538,
    y2: 295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171_10551",
    x1: 300,
    y1: 153,
    x2: 300,
    y2: 329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_171_10551",
    x1: 303,
    y1: 70,
    x2: 303,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_171_10551",
    x1: 317,
    y1: 360,
    x2: 317,
    y2: 408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curated.575aac72593476472d4abda0ac134612.svg";